import { render, staticRenderFns } from "./comp_WordpressPostItemHorizontal.vue?vue&type=template&id=7040a88e&scoped=true&"
import script from "./comp_WordpressPostItemHorizontal.vue?vue&type=script&lang=js&"
export * from "./comp_WordpressPostItemHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./comp_WordpressPostItemHorizontal.vue?vue&type=style&index=0&id=7040a88e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7040a88e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow})
